import NewPassword from "./NewPassword";
import {useAppSelector} from "@hooks/redux-hooks/hooks";
import {selectUser} from "@commons/core.slice";
import React from "react";
import FPNetLogo from "@components/Logo";

const PrimoAccesso: React.FC = () => {
    const currentUser = useAppSelector(selectUser);

    return <>
        <div className="h-full flex flex-col justify-center">
            <div className="">
                <FPNetLogo className="mx-auto h-20 w-auto"/>
                <NewPassword askEmail={true} title={() => {
                    return <h3 className="text-blue-500">Benvenuto <span className="font-semibold">{currentUser!.nome}</span>,
                        questo e' il tuo primo accesso, ti chiediamo gentilmente di inserire una nuova password!</h3>;
                }}/>
            </div>
        </div>
    </>
}

export default PrimoAccesso;